import { CUSTOM_ELEMENTS_SCHEMA, NgModule, ErrorHandler, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgbModule, NgbTooltipModule, NgbPopoverModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

import { PagesModule } from './pages/pages.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import { InterceptorService, LoaderService } from '../app/core/interceptors/interceptor.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { AuthguardGuard } from './authguard.guard';
import { BlankComponent } from './blank/blank.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { Globals } from './globals/globals';
import { AuthenticationService } from './core/services/auth/auth.service';
import { WorkspaceResolve } from './shared/Workspace.resolve';
import { WorkspaceService } from './core/services/workspace/workspace.service';
import { MessageService } from 'primeng/api';
import { ToastrModule } from 'ngx-toastr';
import { FormioModule } from '@formio/angular';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { ToastModule } from 'primeng/toast';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    BlankComponent,
    NotFoundComponent,
  ],
  imports: [
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    PagesModule,
    BrowserAnimationsModule,
    NgbModule,
    FormioModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgbNavModule,
    HttpClientModule,
    NgxSpinnerModule,
    AutoCompleteModule,
    ToastModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true
    }),
    OAuthModule.forRoot(),
    // PWA. `!isDevMode()` keeps the worker out of `ng serve`, where it would serve a
    // stale bundle and make every edit look like it did not apply. `registerWhenStable`
    // holds registration back until the app has settled so it never competes with the
    // first paint; the 30s is the fallback for an app that stays busy.
    // sw-wrapper.js keeps the worker off external and non-GET requests (see that file).
    ServiceWorkerModule.register('sw-wrapper.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [MessageService,
    providePrimeNG({
      theme: {
        preset: definePreset(Aura, {
          semantic: {
            primary: {
              50: '{blue.50}',
              100: '{blue.100}',
              200: '{blue.200}',
              300: '{blue.300}',
              400: '{blue.400}',
              500: '{blue.500}',
              600: '{blue.600}',
              700: '{blue.700}',
              800: '{blue.800}',
              900: '{blue.900}',
              950: '{blue.950}'
            }
          }
        }),
         options: {
          darkModeSelector: 'none'  // This disables automatic dark mode detection
        }
      }
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderService,
      multi: true
    },
    DatePipe,
    AuthguardGuard,
    Globals,
    AuthenticationService,
    WorkspaceResolve,
    WorkspaceService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
